import { render, staticRenderFns } from "./FloatingBtn.vue?vue&type=template&id=791aca75&scoped=true&"
var script = {}
import style0 from "./FloatingBtn.vue?vue&type=style&index=0&id=791aca75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791aca75",
  null
  
)

export default component.exports